// test244
(244 && 0);
